<!-- <p>
  drzava-update works!
</p> -->
<!-- <form (ngSubmit)="f.valid && SaveItem()" #f="ngForm" class="mt-4 pl-2"> -->
  <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <!-- <div ngModelGroup="baseUpdate"> -->
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                #autofocus
                [MaxLength]="200"                
                [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
                [Label]="'DRZAVA.NAZIV.SINGULAR'">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                <span *ngFor="let validation of errorMessages.Naziv">
                  <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)">
                    <span [ngClass]="{'slideInRight': fc.Naziv.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span></span>
                </span>
              </div>
          </div>          
        </div>
        <div class="form-group row">
          <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtISOAlpha2Code"
                formControlName="ISOAlpha2Code"                
                [MaxLength]="2"             
                [ngClass]="{'is-invalid': submitted && fc.ISOAlpha2Code.invalid}"
                [Label]="'DRZAVA.ISOALPHA2CODE.SINGULAR'">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.ISOAlpha2Code.invalid">
                <span *ngFor="let validation of errorMessages.ISOAlpha2Code">
                  <span class="error-message" *ngIf="fc.ISOAlpha2Code.hasError(validation.type)">
                    <span [ngClass]="{'slideInRight': fc.ISOAlpha2Code.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span></span>
                </span>
              </div>
          </div>          
        </div>
        <div class="form-group row">
          <div class="col-md-12">
              <yt-input
                [Type]="'text'"
                name="txtISOAlpha3Code"
                formControlName="ISOAlpha3Code"
                [MaxLength]="3"                
                [ngClass]="{'is-invalid': submitted && fc.ISOAlpha3Code.invalid}"
                [Label]="'DRZAVA.ISOALPHA3CODE.SINGULAR'">
              </yt-input>
              <div class="form-error" *ngIf="submitted && fc.ISOAlpha3Code.invalid">
                <span *ngFor="let validation of errorMessages.ISOAlpha3Code">
                  <span class="error-message" *ngIf="fc.ISOAlpha3Code.hasError(validation.type)">
                    <span [ngClass]="{'slideInRight': fc.ISOAlpha3Code.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span></span>
                </span>
              </div>
          </div>          
        </div>
        <div class="form-group row">
          <div class="col-md-12">
              <yt-number-input-v3
                  #autofocus
                  name="txtISONumericCode"                               
                  [Label]="'DRZAVA.ISONUMERICCODE.SINGULAR'" 
                  formControlName="ISONumericCode"
                  [FormatString]="'1.0-0'"
                  >
              </yt-number-input-v3>   
              <div class="form-error" *ngIf="submitted && fc.ISONumericCode.invalid">
                <span *ngFor="let validation of errorMessages.ISONumericCode">
                  <span class="error-message" *ngIf="fc.ISONumericCode.hasError(validation.type)">
                    <span [ngClass]="{'slideInRight': fc.ISONumericCode.hasError(validation.type), 'animated': true}" translate="{{validation.message}}"></span></span>
                </span>
              </div>           
          </div>          
        </div>
      </div>
    </div>
   
  </div>
<!-- </div> -->
</form>